module.exports = __webpack_public_path__ + "static/media/logo_jolt2.e5a9b57e.jpg";